const apiUrl = { BASE_URL: 'https://5f873ac949ccbb001617724c.mockapi.io' };
export const config = apiUrl;
